import * as appBackActions from "../actionTypes/configActionTypes"

export const setInAppBackPressed = (): appBackActions.SetInAppBackPressed => {
  return {
    type: appBackActions.IN_APP_BACK_PRESSED,
    payload: {}
  };
}

export const resetInAppBackPressed = (): appBackActions.ResetInAppBackPressed => {
  return {
    type: appBackActions.RESET_IN_APP_BACK_PRESSED,
    payload: {}
  };
}